import { type HouseholdChatMessage } from '@/modules/household/chat/contexts/householdChat.context';
import { MessageType } from '@/types/schema';

/**
 * Returns true when the message is a DIAGRAM_MESSAGE message for the saved
 * diagram `diagramArtifactID`. Returns false for every message when
 * `diagramArtifactID` is null, because a diagram that is not saved has no
 * DIAGRAM_MESSAGE messages.
 */
export function isDiagramMessageForArtifact(
  message: HouseholdChatMessage,
  diagramArtifactID: string | null
): boolean {
  return (
    diagramArtifactID !== null &&
    message.type === MessageType.DiagramMessage &&
    message.diagramContent?.diagramArtifactID === diagramArtifactID
  );
}
